import { FC } from 'react';
import { Helmet } from "react-helmet";
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

const Block = styled.div`
  padding-top: 20px;

  .menu-icon {
    margin-right: 10px;
    width: 44px;
    height: 36px;
  }

  h1 {
    color: #515151;
    font-size: 30px;
    font-weight: 700;
  }
`;

interface IProps {
  iconFile?: string;
  parentMenu: string;
  currentMenu: string;
}

const Header: FC<IProps> = ({ iconFile, parentMenu, currentMenu }) => {
  const { t } = useTranslation();

  return (
    <Block className="content-header">
      <Helmet>
        <title>{currentMenu}</title>
      </Helmet>
      <div className="container-fluid">
        <div className="row mb-2">
          <div className="col-sm-6 flex">
            {
              iconFile
                ? <img className="menu-icon" src={`/images/${iconFile}`} alt={t('common.layout.1')} />
                : null
            }            
            <h1 className="m-0">{currentMenu}</h1>
          </div>{/* /.col */}
          <div className="col-sm-6">
            <ol className="breadcrumb float-sm-right">
              <li className="breadcrumb-item">{parentMenu}</li>
              <li className="breadcrumb-item active">{currentMenu}</li>
            </ol>
          </div>{/*/ .col */}
        </div>{/* /.row */}
      </div>{/* /.container-fluid */}
    </Block>
  )
}

export default Header